import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Input from "../../component/Input";
import Community from "./Community";
import { close, open } from "../../redux/popupSlice";

import * as APIS from "../../utils/service";
import { getBase64, readFileAsync, resizedataURL } from "../../utils/utils";
import consts from "../../libs/consts"

const FreeCommunityWrite = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const dispatch = useDispatch();
    const [idx, setIdx] = useState(null);
    const [title, setTitle] = useState("");
    const [contentText, setContentText] = useState("");

    const [inputError, setInputError] = useState("");

    const fileInputRef = useRef();
    const handleFileInput = () => {
        fileInputRef.current.click();
    };
    const [fileList, setFileList] = useState([]);
    const [deletefiles, setdeletefiles] = useState([])

    //파일 업로드 변경
    const handleFileChange = async (e) => {
        setInputError("");
        let targetFiles = Array.from(e.target.files);
        if ((fileList.length + targetFiles.length) > 6) {
            setInputError("최대 6장까지만 업로드할 수 있습니다.");
            return;
        }

        async function preview(arr) {
            let addFiles = [];
            for (let t = 0; t < arr?.length; t++) {
                if (arr[t].type.match('image.*')) {

                    let resizeData = await readFileAsync(arr[t])
                    console.log(arr[t], resizeData)
                    arr[t].base = resizeData
                    arr[t].ext = arr[t]?.name.split('.')[1];
                    arr[t].addtype = true;

                    addFiles.push(arr[t]);
                }
            }
            setFileList(fileList.concat(addFiles));
        }

        preview(targetFiles);
    };

    // 등록 버튼
    const submitBtn = () => {
        if (title.length < 5) {
            setInputError("제목을 5글자 이상 입력해주세요.");
            return;
        }
        // if (contentText.length < 10) {
        //     setInputError("내용을 10글자 이상 입력해주세요.");
        //     return;
        // }

        let sender = {
            title: title,
            desc: contentText,
            files: fileList,
            delete_files: deletefiles
        }

        if (idx) {
            sender.idx = idx;
        }
        console.log(sender);
        dispatch(
            open({
                component: "등록하시겠습니까?",
                title: "커뮤니티 등록",
                button: "등록",
                buttonCencle: "취소",
                titleviewer: true,
                // wideOne: true,
                alert: false,
                onPress: () => {
                    dispatch(close());
                    APIS.postData('/v1/community/insert', sender).then(({ data }) => {
                        navigate(-1);
                    }).catch(({ response }) => {
                        const { data } = response;
                        dispatch(
                            open({
                                component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                                title: '알림',
                                button: "확인",
                                titleviewer: true,
                                alert: false,
                                onPress: () => {
                                    dispatch(close());
                                },
                            })
                        );
                    }).finally(() => {
                    });
                },
                onCancelPress: () => {
                    dispatch(close());
                },
            })
        );
    };

    useEffect(() => {
        // 인풋 창 변경시 에러 리셋처리
        setInputError("");
    }, [title, contentText])

    // 수정하기시 정보 가져오기
    const loadInfo = (id) => {
        let sender = {
            idx: id,
            reload: true
        };
        APIS.postData('/v1/community/get', sender).then(({ data }) => {
            if (data) {
                setTitle(data?.title)
                setContentText(data?.desc)
                setFileList(data?.files)
            }
        }).catch(({ response }) => {
            const { data } = response;
            dispatch(
                open({
                    component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                    title: '알림',
                    button: "확인",
                    titleviewer: true,
                    alert: false,
                    onPress: () => {
                        dispatch(close());
                    },
                })
            );
        }).finally(() => {
        });
    }

    useEffect(() => {
        if (location.state?.idx) {
            setIdx(location.state?.idx);
            loadInfo(location.state?.idx)
            navigate(`${location.search}${location.search}`, { replace: true, state: null });
        } else {
            setIdx(null);
        }
    }, [])

    return (
        <Community>
            <div className="community_write_wrap">
                <div className="title">{idx ? "수정하기" : "작성하기"}</div>
                <div className="lineWidth"></div>
                <div className="community_write_content_wrap">
                    <div className="community_write_content">
                        <p>제목</p>
                        <Input
                            type="text"
                            className={`inputs`}
                            value={title}
                            setValue={setTitle}
                            placeholder="5자 이상 입력해주세요."
                        />
                    </div>
                </div>
                <div
                    className="community_write_content"
                    style={{ alignItems: "flex-start" }}
                >
                    <p>내용</p>
                    <textarea
                        style={{ resize: "none" }}
                        placeholder="상세 내용 작성 (최대 2,000자)"
                        maxLength={2000}
                        onChange={(e) => setContentText(e.target.value)}
                        value={contentText}
                    />
                </div>
                <div className="file_input_wrap">
                    <div className="file_input community_write_content">
                        <p>첨부</p>
                        <div className="file_wrap">
                            <input
                                type="file"
                                style={{ display: "none" }}
                                ref={fileInputRef}
                                onChange={handleFileChange}
                                multiple
                            />
                            <button type="button" onClick={handleFileInput}>
                                이미지 첨부
                            </button>
                            <p>jpg·jpeg·png 파일만 첨부 가능, 최대 6장까지 </p>
                        </div>
                    </div>
                    <div className="preview_wrap">
                        {fileList?.map((v, i) => (
                            <div key={i} className="img_preview">
                                <img
                                    src={v?.base ? v?.base : consts.s3url + "/" + v?.file_path}
                                    alt="preview"
                                    className="preview_img"
                                />
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (v?.file_path) {
                                            setdeletefiles([...deletefiles, v.file_path])
                                        }

                                        setFileList(fileList?.filter((_, i2) => i2 !== i));
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                        <rect x="0.333984" width="16" height="16" rx="4" fill="#101010" />
                                        <path fillRule="evenodd" clipRule="evenodd" d="M5.5683 5.23431C5.88072 4.9219 6.38725 4.9219 6.69967 5.23431L8.53398 7.06863L10.3683 5.23431C10.6807 4.9219 11.1873 4.9219 11.4997 5.23431C11.8121 5.54673 11.8121 6.05327 11.4997 6.36569L9.66536 8.2L11.4997 10.0343C11.8121 10.3467 11.8121 10.8533 11.4997 11.1657C11.1873 11.4781 10.6807 11.4781 10.3683 11.1657L8.53398 9.33137L6.69967 11.1657C6.38725 11.4781 5.88072 11.4781 5.5683 11.1657C5.25588 10.8533 5.25588 10.3467 5.5683 10.0343L7.40261 8.2L5.5683 6.36569C5.25588 6.05327 5.25588 5.54673 5.5683 5.23431Z" fill="white" />
                                    </svg>
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
                {inputError && <p className="input_error">{inputError}</p>}
                <div className="lineWidth"></div>
                <div className="bottom_btn_wrap">
                    <button
                        className="cancel"
                        onClick={() => {
                            navigate(-1);
                        }}
                    >
                        취소
                    </button>
                    <button className="register" onClick={() => {
                        submitBtn();
                    }}>등록</button>
                </div>
            </div>
        </Community>
    );
};

export default FreeCommunityWrite;
